module.exports = __webpack_public_path__ + "assets/img/ground.2499e3dd.png";